import script from "./WarehouseRoutingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarehouseRoutingModal.vue?vue&type=script&setup=true&lang=ts"

import "./WarehouseRoutingModal.vue?vue&type=style&index=0&id=8344c360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8344c360"]])

export default __exports__